import { mapGetters } from 'vuex'

export default {
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({ 
      getPreferredLanguage: 'main/getPreferredLanguage',
      getCurrentCompany: "main/getCurrentCompany",
      getCurrentUser: "main/getCurrentUser"
    }),
  },
  methods: {
    getPageName () {
      /**
       * Based on the url of the current page, return the mixpanel trackable version of it. We need to return the suburl until a specific number or parameter.
       * e.g. https://staging.getgekko.com/nl/trips/view/173/ -> becomes /trips/view/
        */
      var pieces_url = window.location.href.split("/");
      var index_after_language = pieces_url.indexOf(location.host)+2;
      var page_name = "/";
      for (var i=index_after_language; i<pieces_url.length; i++){
        if (/\d/.test(pieces_url[i])) {
          //once you get to an id stop the page name construction
          break;
        } else {
          page_name += pieces_url[i] + "/";
        }
      }
      return page_name;
    },

    genericPageLoad () {
      // console.log('mixpanel.js::genericPageLoad()')
      if (window.mixpanel) {
        window.mixpanel.register({
          'is_authenticated': true
        });

        var page_name = this.getPageName(); // TODO use $route?
        var numberOfPagesTracked;
        try {
          numberOfPagesTracked = this.$cookies.get('numberOfPagesTracked');
        } catch (e) {
          numberOfPagesTracked = 11;
        }
        if (numberOfPagesTracked == undefined || parseInt(numberOfPagesTracked) < 10){
          if (numberOfPagesTracked == undefined) {
              numberOfPagesTracked = 0;
          } else {
            numberOfPagesTracked = parseInt(numberOfPagesTracked);
          }
          window.mixpanel.track("Generic: page loaded", {
            'page_name': page_name,
            "url": window.location.href, // TODO
            "referrer": document.referrer,
            "page order": numberOfPagesTracked,
            "is logged in" : true
          });
          window.mixpanel.people.set({
            "was on web": new Date()
          });
          numberOfPagesTracked ++;

          var d = new Date();
          d.setTime(d.getTime() + ((365 * 10) * 24 * 60 * 60 * 1000));
          var expires = "expires="+d.toUTCString();
          this.$cookies.set('numberOfPagesTracked', numberOfPagesTracked, expires, '/');
        }
      }
    },

    privatePageLoad () {
      // console.log('mixpanel.js::privatePageLoad() ->', this.getPreferredLanguage)

      if (window.mixpanel) {
        window.mixpanel.register({
          "language": this.getPreferredLanguage,
          "is_authenticated": true
        });
    
        if (window.location.href.indexOf("dashboard") != -1) {
          // we are on the dashboard
  
          var peopleProfileData = {
            "premium": this.getCurrentUser.is_premium,
            "$email": this.getCurrentUser.email,
            "date_joined": this.getCurrentUser.date_joined,
            "has accountant": this.getCurrentCompany.has_accountant,
            "$name": this.getCurrentUser.display_name,
            'legal_form': this.getCurrentCompany.legal_form
          };
  
          //check if a user signed up via an external campaign or saw it after signup
          var firstCampaignSeen = this.$cookies.get('firstCampaignSeen');
          var firstCampaignSeenDate = this.$cookies.get('firstCampaignSeenDate');
          
          var date_user_joined =  new Date(this.getCurrentUser.date_joined);
          if (firstCampaignSeenDate && new Date(firstCampaignSeenDate) > date_user_joined) {
            window.mixpanel.people.set_once('utm-signedUpBeforeFirstCampaign', firstCampaignSeenDate);
            window.mixpanel.track("External campaign seen after signup", {
              name: firstCampaignSeen,
              'date seen' : firstCampaignSeenDate
            })
          }
          var lastCampaignSeen = this.$cookies.get('lastCampaignSeen');
          var lastCampaignSeenDate = this.$cookies.get('lastCampaignSeenDate');
  
          if (lastCampaignSeen && new Date(lastCampaignSeenDate) > date_user_joined) {
            window.mixpanel.track("External campaign seen after signup", {
              name: lastCampaignSeen,
              'date seen': lastCampaignSeenDate
            })
          }
          window.mixpanel.people.set(peopleProfileData);
          window.mixpanel.register({
              "premium": this.getCurrentUser.is_premium
          });
          window.mixpanel.identify(this.getCurrentUser.email);
        }
        if (window.location.href.indexOf("marketplace") != -1) {
          window.mixpanel.track("Generic: page loaded", {
              'page_name': 'marketplace',
              "url": window.location.href,
              "referrer": document.referrer
          });
          window.mixpanel.time_event("Marketplace: session time");
        }
        if (document.referrer.indexOf("marketplace") != -1 && window.location.href.indexOf("marketplace") == -1) {
          window.mixpanel.track("Marketplace: session time");
        }
      }
    }


  }
}